@if (hasError) {
  <div class="error-container" [style.min-height]="minHeight">
    <i class="iwp-icon-gen_show_error_warning" style="font-size: 50px; margin-bottom: 10px"></i>
    @if (canReload) {
      <div class="left-margin">
        An error occured. Please <u style="cursor: pointer;" (click)="reload.next()">try again</u> later.
      </div>
    }
    @if (!canReload) {
      <div class="left-margin">
        An error occured. Please try again later.
      </div>
    }
  </div>
}